import React from 'react';

import UserDetails from "../user-details/user-details.jsx";
import {validateEmail} from "../../services/functions";
import {
    getTotalItems,
    getTotalPrice
} from "../../services/cart";


const AdditionalInfo = (props)=>{

    const {
        teeth,
        setCurrency,
        currency,
        fieldsState,
        setFields,
        bridges,
        setCurScreen
    } = props;

    const isFormFilled = ()=>{

        for(const field in fieldsState){
            if(!fieldsState[field]) return false;
        }
        return  !!getTotalPrice(teeth,currency,bridges) && validateEmail(fieldsState.docEmail);
    }

    return(
        <div id='additional-info'>
            <p className='additional'>{abraStr.additionalInfo}</p>

            <div className='summary'>
                <div className='top'>
                    {<UserDetails
                        fieldsState={fieldsState}
                        setFields={setFields}
                        setCurrency={setCurrency}
                    />}
                    <h3>{abraStr.summary}</h3>
                    <div className='flex '>
                        <p>{abraStr.totalItems}</p>
                        <span>{getTotalItems(teeth,bridges) || "--"}</span>
                    </div>
                </div>
                <div className='bottom'>
                    <div className='flex'>
                        <p>{abraStr.totalPrice}</p>
                        <span>{getTotalPrice(teeth,currency,bridges) || "--"}</span>
                    </div>
                </div>
            </div>
            <button
                className={isFormFilled()? "active" : ""}
                onClick={()=>{isFormFilled() && setCurScreen("review")}}
            >
                {abraStr.review}
            </button>
        </div>
    );
}

export default AdditionalInfo;